import {
  Box,
  Button,
  Card,
  Divider,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import DashboardLayout from "../../components/dashboard/DashboardLayout";

export default function MappingPage() {
  const mappingRows = [
    {
      source: "Item Code",
      target: "sku_code",
      required: true,
      example: "ADI-001",
    },
    {
      source: "Product Name",
      target: "name",
      required: true,
      example: "Adidas Sneakers",
    },
    {
      source: "Category",
      target: "category",
      required: false,
      example: "Footwear",
    },
    {
      source: "Size",
      target: "size",
      required: false,
      example: "8",
    },
  ];

  return (
   <DashboardLayout activePage="Mappings">
     <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 3 }}
      >
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Mappings
          </Typography>

          <Typography color="text.secondary">
            Configure how your CSV fields map into StockMove analytics
          </Typography>
        </Box>

        <Button variant="contained">Create Mapping</Button>
      </Stack>

      <Card sx={{ p: 3, mb: 3 }}>
        <Stack direction="row" spacing={3}>
          <Box>
            <Typography variant="body2">Profile</Typography>
            <Select size="small" defaultValue="default">
              <MenuItem value="default">Default CSV</MenuItem>
            </Select>
          </Box>

          <Box>
            <Typography variant="body2">Entity</Typography>
            <Select size="small" defaultValue="products">
              <MenuItem value="products">Products</MenuItem>
              <MenuItem value="sales">Sales</MenuItem>
            </Select>
          </Box>
        </Stack>
      </Card>

      <Card sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Field Mapping
        </Typography>

        <Divider sx={{ mb: 2 }} />

        <Table>
          <TableHead>
            <TableRow>
              <TableCell>CSV Column</TableCell>
              <TableCell>Maps To</TableCell>
              <TableCell>Required</TableCell>
              <TableCell>Example</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {mappingRows.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.source}</TableCell>

                <TableCell>
                  <Select
                    size="small"
                    defaultValue={row.target}
                    sx={{ minWidth: 180 }}
                  >
                    <MenuItem value="sku_code">SKU</MenuItem>
                    <MenuItem value="name">Product Name</MenuItem>
                    <MenuItem value="category">Category</MenuItem>
                    <MenuItem value="size">Size</MenuItem>
                    <MenuItem value="color">Color</MenuItem>
                  </Select>
                </TableCell>

                <TableCell>
                  {row.required ? "Yes" : "No"}
                </TableCell>

                <TableCell>{row.example}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 3 }}>
          <Button variant="contained">Save Mapping</Button>
        </Stack>
      </Card>
    </Box>
   </DashboardLayout>
  );
}